<template>
  <div class="events">
    <div class="events__header container">
      <h1 class="events__header-title">{{ $t("events.title") }}</h1>
    </div>

    <div class="events-add" v-if="loading">
      <div class="container">
        <EventCardSkeleton v-for="n in perPage" :key="`skeleton-${n}`" />
      </div>
    </div>

    <div
      class="container events__middle-container"
      v-if="!loading && !events.length"
    >
      <div class="events__message">{{ $t("events.noEventsMessage") }}</div>
    </div>

    <div class="events-add" v-if="events.length">
      <div class="container">
        <template v-if="!paginationLoading">
          <EventCard
            v-for="event in reverseEvents"
            :key="event.id"
            :event="event"
            @click="goToEvent(event)"
          />
        </template>
        <template v-else>
          <EventCardSkeleton
            v-for="n in perPage"
            :key="`pagination-skeleton-${n}`"
          />
        </template>
      </div>
      <Pagination
        v-if="pageAmount > 1"
        :page="currentPage"
        :page-count="pageAmount"
        :total-visible="paginationPageAmount"
        :disabled="paginationLoading"
        @change="paginate"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { Pagination } from "@v2/shared/ui/components";
import { EventCard, EventCardSkeleton, eventApi } from "@v2/entities/event";

export default {
  name: "EventsPage",

  components: {
    Pagination,
    EventCard,
    EventCardSkeleton
  },

  data() {
    return {
      loading: false,
      paginationLoading: false,
      events: [],
      reverseEvents: [],
      currentPage: +this.$route.query?.page || 1,
      pageAmount: 1,
      perPage: 5
    };
  },

  computed: {
    ...mapGetters("auth", {
      userId: "userId"
    }),

    paginationPageAmount() {
      return window.innerWidth > 570 ? 5 : 2;
    }
  },

  methods: {
    goToEvent(event) {
      this.$router.push({
        name: "participant",
        params: {
          id: event.id
        }
      });
    },

    async fetchEvents(perPage, currentPage) {
      const response = await eventApi.all(perPage, currentPage);
      if (response?.data) {
        this.events = response.data;
        this.pageAmount = response.meta.last_page;
        this.reverseEvents = this.sortExhibitionsByStartDate(response.data);
      }
    },

    sortExhibitionsByStartDate(events) {
      return events.sort(
        (a, b) =>
          moment(b.exhibition.started_at) - moment(a.exhibition.started_at)
      );
    },

    async paginate(page) {
      try {
        this.paginationLoading = true;
        this.currentPage = page;
        await this.fetchEvents(this.perPage, page);
        const url = new URL(window.location.href);
        url.searchParams.set("page", page);
        window.history.replaceState(null, null, url);
      } finally {
        this.paginationLoading = false;
      }
    }
  },

  async created() {
    this.loading = true;
    await this.fetchEvents(this.perPage, this.currentPage);
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.events {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  flex-grow: 1;

  &__header {
    width: 100%;

    @include respond-down(md) {
      width: calc(100% - 16px * 2);
    }

    &-title {
      opacity: 0.85;
      font-family: Roboto, serif;
      font-size: 34px;
      font-weight: bold;
      line-height: 1.18;
      color: #000000;
      margin: 39px 0 25px 0;

      @include respond-down(md) {
        font-size: 20px;
        margin-top: 24px;
      }
    }
  }

  &__middle-container {
    margin: auto;
  }

  &__message {
    @include description();
    font-size: 16px;
  }

  &-add {
    background-color: #f9f9f9;
    padding: 10px 0 32px 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    @include respond-down(md) {
      padding: 24px 0;
    }
  }
}
</style>
